// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"PersonalDetailsStep_loadingWrapper__q8as+"};